import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { getEnvConfig } from "@catchoftheday/env-config";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var StripeElementsProvider = function StripeElementsProvider(props) {
  var _getEnvConfig = getEnvConfig(),
      STRIPE_PK = _getEnvConfig.STRIPE_PK;

  if (!STRIPE_PK) {
    console.warn("Stripe Elements will not be rendered as STRIPE_PK is not defined.");
    return null;
  }

  var stripePromise = loadStripe(STRIPE_PK);
  return ___EmotionJSX(Elements, _extends({
    stripe: stripePromise
  }, props));
};